const hostname = window.location.hostname;
export const isAppSite = hostname === 'app.ecotrack.ai' || hostname === 'ecotrack-win616.web.app';
export const loginHref = isAppSite ? '/sign-in' : 'https://app.ecotrack.ai/sign-in';
